import {useNavigate} from 'react-router-dom'
import {Input} from 'antd'
import {Rule} from 'antd/lib/form'

import {Button, Form, FormItem} from 'common/components'
// import {PASSWORD_FIELD_RULES} from 'common/constants'
import {showErrorNotification} from 'common/helpers'
import {useRestorePassword} from '..'

const PASSWORD_FIELD_RULES: Rule[] = [
  {required: true, message: 'Please input password'},
  {
    message: "Minimum 8 characters, 1 capital letter, letters and numbers",
    validator(_: any, value: string) {
      if (/(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(value)) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
  },
]

export default function PasswordRestoreForm({token, email}:{
  token: string;
  email: string;
}) {
  const navigate = useNavigate()
  const {mutate: resetPassword, isMutating} = useRestorePassword(() =>
    navigate('/login')
  )

  const handleFinish = (values: any) => {
    if (values.password !== values.password_confirmation) {
      showErrorNotification('Password not match!')
      return
    }
    resetPassword({
      token, email,
      ...values
    })
  }

  return (
    <Form onFinish={handleFinish}>
      <div style={{textAlign: 'left'}}>
        <FormItem
          name="password"
          label="New password"
          // help="Minimum 8 characters, 1 capital letter, letters and numbers"
          rules={PASSWORD_FIELD_RULES}
        >
          <Input.Password autoFocus />
        </FormItem>
        <FormItem
          name="password_confirmation"
          label="Repeat password"
          // help="Minimum 8 characters, 1 capital letter, letters and numbers"
          rules={PASSWORD_FIELD_RULES}
        >
          <Input.Password />
        </FormItem>
      </div>
      <Button block htmlType="submit" loading={isMutating}>
        Reset password
      </Button>
    </Form>
  )
}
